module.exports = __webpack_public_path__ + "img/lottery-bg.4fed465b.png";